module.exports = __webpack_public_path__ + "img/error.a2a4c4ef.png";